import React, { Component } from 'react'
import classNames from 'classnames'
import { CaretBottomIcon } from 'components/Utils/Icons'
import SelectMe from 'react-select-me'
import 'react-select-me/lib/ReactSelectMe.css'
import './style.css'

// THIS SHOULD BE DELETED, WE USE EITHER DROPDOWN OR SELECTROLE

export default class Select extends Component {
  static defaultProps = {
    listMaxHeight: 450,
    optionRenderer(option, selectedOptions) {
      const isSelected = selectedOptions.includes(option)
      return (
        <div
          className={classNames(
            'pointer padding-medium font-size-normal',
            'shade-05',
            isSelected
              ? 'background-shade-50'
              : 'background-shade-100 background-shade-50-on-hover'
          )}
        >
          <div className="font-weight-medium">{option.label}</div>
          {option.description && (
            <div className="shade-20 margin-top-small">
              {option.description}
            </div>
          )}
        </div>
      )
    },
  }

  constructor(props) {
    super(props)
    this.nativeSelectRef = React.createRef()
  }

  render() {
    return (
      <React.Fragment>
        <select
          ref={this.nativeSelectRef}
          id={this.props.id}
          required={this.props.required}
          style={{
            width: 1,
            marginLeft: -1,
            border: 'none',
            background: 'transparent',
          }}
          defaultValue={Boolean(this.props.value) ? '1' : ''}
        >
          <option value="" />
          <option value="1" />
        </select>
        <SelectMe
          disabled={this.props.disabled}
          searchable={this.props.searchable}
          value={this.props.value || undefined}
          options={this.props.options}
          placeholder={this.props.placeholder}
          onSearch={this.props.onSearch}
          listMaxHeight={this.props.listMaxHeight}
          s={{
            dd__wrapper: classNames(
              'color-mode-elevated',
              this.props.className
            ),
            dd__selectControl: classNames(
              'flexbox flexbox-space-between pointer center-text position-relative background-transparent border-solid radius-normal border-small padding-horizontal-normal padding-right-large dd__wrapper_border_override',
              {
                'border-shade-40 border-primary-on-hover shade-20 shade-10-on-hover ': !this
                  .props.disabled,
                'cursor-forbidden border-shade-40 shade-30 disabled': this.props
                  .disabled,
              }
            ),
            dd__list: classNames(
              'dd__list_border_override',
              this.props.listClassName
            ),
            dd__search: 'text-align-left',
          }}
          optionRenderer={this.props.optionRenderer}
          optionHeight={48}
          iconRenderer={() => {
            return <CaretBottomIcon size={16} />
          }}
          onChange={option => {
            // react-select-me doesn't handle the required attribute
            // Let's do it in its stead
            this.nativeSelectRef.current.selectedIndex = 1
            this.props.onChange(option.value)
          }}
          {...this.props.extraProps}
        />
      </React.Fragment>
    )
  }
}
